import { PortfolioList, WEDDINGS_CFG } from "@/components/Portfolio";
export default function WeddingsPortfolio() {
  return <PortfolioList cfg={WEDDINGS_CFG} />;
}
